import { useCategoryPageQueryParams } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
/** This parses the URL and returns the page number. */ export var useOneIndexedPageNumber = function() {
    return useCategoryPageQueryParams().oneIndexedPageNumber;
};
